import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import Dropdown from "components/Input/Dropdown"
import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit, InsertDateFormat, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import { ApiCreateCashIn, ApiDeleteCashIn, ApiDeleteCustomerCard, ApiGetBankList, ApiGetCardVendorList, ApiGetCashInById, ApiGetCustomerCard, ApiGetCustomerList, ApiInsertCustomerCard, ApiUpdateCashIn, ApiUpdateCustomerCard } from "utils/constants/api"
import useFetch from "utils/hooks/useFetch"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import moment from "moment"
import { decimal, GetStatus, money, removeNonNumeric } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import Select from 'react-select'
import DatePicker from "components/Input/DatePicker"

export default function CashInForm(){
    const navigate = useNavigate()

    const { fetch: insertCustomerCard } = useFetch(ApiInsertCustomerCard)
    const { fetch: updateCustomerCard } = useFetch(ApiUpdateCustomerCard)
    const { fetch: deleteCustomerCard } = useFetch(ApiDeleteCustomerCard)
    const { fetch: getCustomerCard } = useFetch(ApiGetCustomerCard)
    const { fetch: getCustomerList } = useFetch(ApiGetCustomerList)
    const { fetch: getBankList } = useFetch(ApiGetBankList)
    const { fetch: getCardVendorList } = useFetch(ApiGetCardVendorList)

    const { fetch: apiInsertCashIn } = useFetch(ApiCreateCashIn)
    const { fetch: apiUpdateCashIn } = useFetch(ApiUpdateCashIn)
    const { fetch: apiDeleteCashIn } = useFetch(ApiDeleteCashIn)
    const { fetch: apiGetCashInById } = useFetch(ApiGetCashInById)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramCustomerCardId = queryString.get("customerCardId")
    let paramCashInId = queryString.get("cashInId")

    const [customerName, setCustomerName] = useState(EmptyString)

    const [cashInDate, setCashInDate] = useState(new Date())
    const [amount, setAmount] = useState(EmptyString)
    const [remark, setRemark] = useState(EmptyString)

    // Form State

    const [cardNumber, setCardNumber] = useState(EmptyString)
    const [bankId, setBankId] = useState(EmptyString)
    const [bankOptions, setBankOptions] = useState([])
    const [cardVendorId, setCardVendorId] = useState(EmptyString)
    const [cardVendorOptions, setCardVendorOptions] = useState([])
    const [customerId, setCustomerId] = useState(EmptyString)
    const [customerOptions, setCustomerOptions] = useState(EmptyString)
    const [expiredMonth, setExpiredMonth] = useState(EmptyString)
    const [expiredYear, setExpiredYear] = useState(EmptyString)
    const [vcc, setVcc] = useState(EmptyString)
    const [mdr, setMdr] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)
    
    const [errorCardNumber, setErrorCardNumber] = useState(false)
    const [errorBankId, setErrorBankId] = useState(false)
    const [errorCardVendorId, setErrorCardVendorId] = useState(false)
    const [errorCustomerId, setErrorCustomerId] = useState(false)
    const [errorExpiredMonth, setErrorExpiredMonth] = useState(false)
    const [errorExpiredYear, setErrorExpiredYear] = useState(false)
    const [errorVcc, setErrorVcc] = useState(false)
    const [errorMdr, setErrorMdr] = useState(false)
    
    const cardNumberChange = (e) => { setCardNumber(removeNonNumeric(e.target.value)) }
    const bankIdChange = (e) => { setBankId(e.value) }
    const cardVendorIdChange = (e) => { setCardVendorId(e.value) }
    const customerIdChange = (e) => { setCustomerId(e) }
    const expiredMonthChange = (e) => { setExpiredMonth(removeNonNumeric(e.target.value)) }
    const expiredYearChange = (e) => { setExpiredYear(removeNonNumeric(e.target.value)) }
    const vccChange = (e) => { setVcc(removeNonNumeric(e.target.value)) }
    const mdrChange = (e) => { setMdr(decimal(e.target.value)) }

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
    const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        

        if (formType === FormTypeEdit){
            setLoading({isOpen: true})

            getCashInById().then(() => {
                setLoading({isOpen: false})
            })
        }
        
    }, [])

    // Function Api Call
    async function fGetCustomerCard(){
        await getCustomerCard({
            data: {
                customerCardId: paramCustomerCardId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data

                setCustomerId({label: data.customerName, value: String(data.customerId)})
                setCardNumber(data.cardNumber)
                setBankId(String(data.bankId))
                setCardVendorId(String(data.cardVendorId))
                setExpiredMonth(data.expiredMonth)
                setExpiredYear(data.expiredYear)
                setVcc(data.vcc)
                setMdr(data.mdr)
                setStatus(data.status)
                setCreateDate(data.createDate)
                setUpdateDate(data.updateDate)
                setUpdateBy(data.updateBy)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fInsertCustomerCard(){
        await insertCustomerCard({
            data:{
                customerId: customerId.value,
                cardNumber: cardNumber.trim(),
                bankId: bankId,
                cardVendorId: cardVendorId,
                expiredMonth: expiredMonth,
                expiredYear: expiredYear,
                vcc: vcc,
                mdr: mdr
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { 
                    setSuccessModal({isOpen: false})
                    // navigate("/customer-card") 
                }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fUpdateCustomerCard(){
        await updateCustomerCard({
            data:{
                customerCardId: paramCustomerCardId,
                customerId: customerId.value,
                cardNumber: cardNumber,
                bankId: bankId,
                cardVendorId: cardVendorId,
                expiredMonth: expiredMonth,
                expiredYear: expiredYear,
                vcc: vcc,
                mdr: mdr
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/customer-card") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fDeleteCustomerCard(){
        await deleteCustomerCard({
            data:{
                customerCardId: paramCustomerCardId,
                status: status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/customer-card") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetCustomerList(){
        await getCustomerList({
            data: {
                customerName: customerName,
                address: EmptyString, 
                phone: EmptyString,
                status: StatusCodeActive,
                pageSize: 10000,
                pageIndex: 0
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                if (response.data.listData.length > 0){
                    let data = response.data.listData
                    let tempArray = []

                    tempArray.push({ label: "Select Customer", value: "" })

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: data[i].customerName.toUpperCase(), value: String(data[i].customerId) })
                    }

                    setCustomerOptions(tempArray)
                    setCustomerId(tempArray[0].value)
                }
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetBankList(){
        await getBankList({
            data: {
                bankCode: EmptyString,
                bankName: EmptyString, 
                status: StatusCodeActive,
                pageSize: 1000,
                pageIndex: 0
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                if (response.data.listData.length > 0){
                    let data = response.data.listData
                    let tempArray = []

                    tempArray.push({ label: "All", value: "" })

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: data[i].bankCode + " - " + data[i].bankName, value: String(data[i].bankId) })
                    }

                    setBankOptions(tempArray)
                    setBankId(tempArray[0].value)
                }
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetCardVendorList(){
        await getCardVendorList({
            data: {
                cardVendorName: EmptyString,
                status: StatusCodeActive,
                pageSize: 1000,
                pageIndex: 0
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                if (response.data.listData.length > 0){
                    let data = response.data.listData
                    let tempArray = []

                    tempArray.push({ label: "All", value: "" })

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: data[i].cardVendorName, value: String(data[i].cardVendorId) })
                    }

                    setCardVendorOptions(tempArray)
                    setCardVendorId(tempArray[0].value)
                }
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    const insertCashIn = async () => {
        await apiInsertCashIn({
            data: {
                cashInDate: moment(cashInDate).format(InsertDateFormat),
                amount: amount.replaceAll(",", ""),
                remark: remark
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                        setSuccessModal({isOpen: false})
                            navigate(-1) 
                        }
                    } 
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    const updateCashIn = async () => {
        await apiUpdateCashIn({
            data: {
                cashInId: paramCashInId,
                cashInDate: moment(cashInDate).format(InsertDateFormat),
                amount: amount.replaceAll(",", ""),
                remark: remark
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                        setSuccessModal({isOpen: false})
                            navigate(-1) 
                        }
                    } 
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    const deleteCashIn = async () => {
        await apiDeleteCashIn({
            data: {
                cashInId: paramCashInId,
                status: status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                        setSuccessModal({isOpen: false})
                            navigate(-1) 
                        }
                    } 
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    const getCashInById = async () => {
        await apiGetCashInById({
            data: {
                cashInId: paramCashInId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data

                setCashInDate(data.cashInDate)
                setAmount(money(data.amount))
                setRemark(data.remark)
                setStatus(data.status)
                setCreateDate(data.createDate)
                setUpdateDate(data.updateDate)
                setUpdateBy(data.updateBy)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Button Click Handlers
    const saveBtnClick = () => {
        if (validateForm()){
            setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
                setConfirmationModal({ isOpen: false })
                setLoading({isOpen: true})

                if (formType === FormTypeAdd){
                    insertCashIn().then(() => {
                        setLoading({isOpen: false})
                    })
                }else{
                    updateCashIn().then(() => {
                        setLoading({isOpen: false})
                    })
                }
            }}})
        }
    }
    const deleteBtnClick = () => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})

            deleteCashIn().then(() => {
                setLoading({isOpen: false})
            })
        }}})
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    function validateForm(){
        let isValid = true

        return isValid
    }

    return (
        <div className="flex flex-col gap-2">
            <div>
                <div className="flex justify-between">
                    <span className="font-semibold text-2xl">Cash In Detail</span>
                    <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                        <span className="text-sm opacity-60">
                            Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                        </span>
                    </div>
                </div>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                {/* Customer */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Cash In Date</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <DatePicker className="h-11 bg-white w-full" value={cashInDate} onChange={(date) => setCashInDate(date)} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorCustomerId ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Customer is required!</span>
                    </div>
                </div>

                {/* Amount */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Amount</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={amount} onChange={(e) => setAmount(money(e.target.value))} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorCardNumber ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Card Number is required!</span>
                    </div>
                </div>

                {/* Remark */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Remark</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={remark} onChange={(e) => setRemark(e.target.value.toUpperCase())} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorBankId ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Bank is required!</span>
                    </div>
                </div>
            </div>
                

            <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <DeleteButton onClick={deleteBtnClick} visible={ formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false) } />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                <BackButton onClick={backBtnClick}  />
            </div>

             {/* Modal */}
 			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
 			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}